module.exports = __webpack_public_path__ + "static/profile_photo-918426a78b3dd3cb3f188f393d11df4e.jpg";